import { render, staticRenderFns } from "./PageAssetReportMaster.vue?vue&type=template&id=355c703d&scoped=true"
import script from "./PageAssetReportMaster.vue?vue&type=script&lang=js"
export * from "./PageAssetReportMaster.vue?vue&type=script&lang=js"
import style0 from "./PageAssetReportMaster.vue?vue&type=style&index=0&id=355c703d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c703d",
  null
  
)

export default component.exports